import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import HubspotForm from '../../components/hubspot-form';
import PageLayout from '../../components/page-layout';
import Section from '../../components/section';
import Seo from '../../components/seo';

const useStyles = makeStyles(theme => ({
  titleSection: {
    marginBottom: theme.spacing(-8),
  },
}));

const ContactUsPage: React.FC = () => {
  const classes = useStyles();

  return (
    <PageLayout>
      <Seo
        title="Contact us"
        description="Learn more about Architect by contacting our team directly"
      />

      <Section maxWidth="md" variant="hero-green" className={classes.titleSection}>
        <Typography variant="h1" align="center">
          Contact Us
        </Typography>
        <Typography variant="subtitle1" align="center">
          Have any questions about the product or pricing? Shoot us a message with the form below,
          and we'd be happy to answer your questions!
        </Typography>
      </Section>

      <Section maxWidth="md" verticalSpacing={8}>
        <HubspotForm
          formId="a8f57c7d-43d0-4e57-b53e-81f637a59065"
          redirectUrl="/contact-us/success"
        />
      </Section>
    </PageLayout>
  );
};

export default ContactUsPage;
